export default __webpack_public_path__ + "static/media/mentalidade-empreendedora.1480e2b2.png";